<script setup>
import { ref, defineProps } from 'vue';

const props = defineProps({
  decimal: {
    type: Number,
    default: 2,
  },
  isNumber: {
    type: Boolean,
    default: true,
  },
  maxNumber: {
    type: Number,
    default: 9999999999,
  },
  minNumber: {
    type: Number,
    default: 0,
  },
  disableNumberNegative: {
    type: Boolean,
    default: false,
  },
  textAlign: {
    type: String,
    default: 'text-end',
  },
  isThousands: {
    type: Boolean,
    default: true,
  },
  isAllowBlank: {
    type: Boolean,
    default: false,
  },
  isMasked: {
    type: Boolean,
    default: false,
  },
  minimumNumberOfCharacters: {
    type: Number,
    default: 0,
  },
});

const config = ref({
  debug: false,
  masked: props.isMasked,
  prefix: '',
  suffix: '',
  thousands: props.isThousands ? '.' : '',
  decimal: ',',
  disableNegative: props.disableNumberNegative,
  disabled: false,
  min: props.minNumber,
  max: props.maxNumber,
  allowBlank: props.isAllowBlank,
  minimumNumberOfCharacters: props.minimumNumberOfCharacters,
  modelModifiers: {
    number: props.isNumber,
  },
});
</script>

<template>
  <money3 v-bind="config" :precision="props.decimal" class="form-control" v-bind:class="props.textAlign" />
</template>
<style scoped>
::placeholder {
  text-align: left;
}
</style>
